"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _Slider = require("../common/Slider/Slider");
var _FormItem = require("../form/FormItem");
var _NumberInput = require("../form/NumberInput");
var _numberFormatter = require("../../helpers/numberFormatter");
var _MarginAssetOptionsDnd = _interopRequireDefault(require("../MarginAssetOptionsDnd/MarginAssetOptionsDnd"));
require("./MarginRepayLoanComponent.css");
var _formValidations = require("../../helpers/formValidations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('repay-loan-modal');
var formatMoney = function formatMoney(value, _ref) {
  var DecimalPlaces = _ref.DecimalPlaces,
    Product = _ref.Product;
  return "".concat((0, _numberFormatter.formatNumberToLocale)(value, DecimalPlaces || Product), " ").concat(Product);
};
var gtZero = (0, _formValidations.greaterThanValue)(0);
var MarginRepayLoanFormComponent = function MarginRepayLoanFormComponent(props) {
  var _position$instrument;
  var handleSubmit = props.handleSubmit,
    position = props.position,
    isOpen = props.isOpen,
    notionalProduct = props.notionalProduct,
    repaymentAssetOptions = props.repaymentAssetOptions,
    reduxFormChange = props.reduxFormChange,
    repayMarginPosition = props.repayMarginPosition,
    closeModal = props.closeModal,
    invalid = props.invalid,
    sliderValue = props.sliderValue,
    repaymentAmount = props.repaymentAmount;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    repaymentOptions = _useState2[0],
    setRepaymentOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    repaymentOptionsUpdatedFlag = _useState4[0],
    setRepaymentOptionsUpdatedFlag = _useState4[1];
  var liability = position.BorrowedAmount;
  var baseNotionalDecimalPlaces = notionalProduct.DecimalPlaces;
  var greaterThanMaxLiability = (0, _react.useCallback)(function (value) {
    return value > liability;
  }, [liability]);
  (0, _react.useEffect)(function () {
    if (Array.isArray(repaymentAssetOptions) && repaymentAssetOptions.length > 0 && !repaymentOptionsUpdatedFlag) {
      setRepaymentOptions(repaymentAssetOptions);
      // Prevents updates to list order when form values are entered
      setRepaymentOptionsUpdatedFlag(true);
    }
  }, [repaymentAssetOptions]);
  var isDisabled = (0, _react.useMemo)(function () {
    return invalid || repaymentAmount <= 0 || !repaymentOptions.some(function (item) {
      return item.checked;
    });
  }, [invalid, repaymentOptions, repaymentAmount]);
  var onAssetOptionsOrderChange = function onAssetOptionsOrderChange(newOrder) {
    setRepaymentOptions(newOrder);
  };
  var onCheckboxChange = function onCheckboxChange(id) {
    setRepaymentOptions(function (prevOptions) {
      var updatedRepaymentOptions = prevOptions.map(function (item) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
          checked: !item.checked
        }) : item;
      });
      return updatedRepaymentOptions;
    });
  };
  var onSubmit = function onSubmit(values) {
    var checkedOptions = repaymentOptions.filter(function (item) {
      return item.checked;
    });
    var productIds = checkedOptions.map(function (product) {
      return product.ProductId;
    });
    // Liability below is rounded down, which is consistent with how we round display values throughout TradingUI
    var liabilityRounded = (0, _numberFormatter.truncateToDecimals)(liability, position.borrowedProduct.DecimalPlaces);
    var rawPctToRepay = values.repaymentAmount / Number(liabilityRounded);
    // Product decided to round PercentageToRepay to 8 decimal places
    var PercentageToRepay = Math.min(rawPctToRepay.toFixed(8), 1);
    repayMarginPosition({
      AccountId: position.AccountId,
      PositionId: position.PositionId,
      PositionInstrumentId: position.PositionInstrumentId,
      PercentageToRepay: PercentageToRepay,
      RepaymentAssets: productIds,
      Instrument: position.instrument,
      PositionType: position.PositionType
    });
    closeModal();
  };
  var onSliderChange = (0, _react.useCallback)(function (value) {
    var sliderPct = value / 100;
    var newRepaymentAmount = liability * sliderPct;
    reduxFormChange('repaymentAmount', newRepaymentAmount);
  }, [liability, reduxFormChange]);
  if (!isOpen || !position) return null;
  var positionDetails = [{
    label: "".concat(t('Pair'), ":"),
    text: (_position$instrument = position.instrument) === null || _position$instrument === void 0 ? void 0 : _position$instrument.Symbol
  }, {
    label: "".concat(t('Position'), ":"),
    text: position.PositionType
  }, {
    label: "".concat(t('Size'), ":"),
    text: formatMoney(position.PositionAmount, position.positionProduct)
  }, {
    label: "".concat(t('Cost Basis'), ":"),
    text: formatMoney(position.CostBasis, position.quoteProduct)
  }, {
    label: "".concat(t('Position Value'), ":"),
    text: formatMoney(position.PositionValue, position.quoteProduct)
  }, {
    label: "".concat(t('Interest Accrued'), ":"),
    text: formatMoney(position.InterestAccrued, position.PositionType === 'Long' ? position.borrowedProduct : position.positionProduct)
  }, {
    label: "".concat(t('Unrealized P&L'), ":"),
    text: formatMoney(position.UnrealizedPnL, notionalProduct)
  }, {
    label: "".concat(t('Remaining Liability'), ":"),
    text: formatMoney(liability, position.PositionType === 'Long' ? position.borrowedProduct : position.positionProduct)
  }];
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    className: bemClasses('margin-repay-loan-form')
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: bemClasses('position-details-title')
  }, t('Position Details')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('position-details-table')
  }, positionDetails.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: bemClasses('transaction-details-title')
  }, t('Transaction Details')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('repay-amount-container')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.AmountInput,
    layout: "horizontal",
    name: "repaymentAmount",
    label: "".concat(t('Amount to Repay'), ":"),
    placeholder: "0",
    symbol: position.borrowedProduct.Product,
    decimalPlaces: position.borrowedProduct.DecimalPlaces,
    validate: [gtZero, greaterThanMaxLiability]
  }), /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    onChange: onSliderChange,
    value: sliderValue,
    breakpoints: [0, 100]
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "repay-order-description"
  }, t('We will repay your liability by using your collateral assets in the following order:')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('repay-list-container')
  }, /*#__PURE__*/_react["default"].createElement(_MarginAssetOptionsDnd["default"], {
    repaymentOptions: repaymentOptions,
    onAssetOptionsOrderChange: onAssetOptionsOrderChange,
    onCheckboxChange: onCheckboxChange,
    baseNotionalDecimalPlaces: baseNotionalDecimalPlaces
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    styleName: "additive",
    disabled: isDisabled
  }, t('Submit'))));
};
MarginRepayLoanFormComponent.propTypes = {
  t: _propTypes["default"].func,
  handleSubmit: _propTypes["default"].func,
  position: _propTypes["default"].object,
  isOpen: _propTypes["default"].bool,
  notionalProduct: _propTypes["default"].object,
  repaymentAssetOptions: _propTypes["default"].array,
  reduxFormChange: _propTypes["default"].func,
  repayMarginPosition: _propTypes["default"].func,
  closeModal: _propTypes["default"].func,
  repaymentAmount: _propTypes["default"].number
};
var _default = exports["default"] = MarginRepayLoanFormComponent;